import { CategoryQuestions } from '../types';

export const beStillQuestions: CategoryQuestions = {
  title: 'Personalize Your Emotional Reset Session',
  questions: {
    preferredStyle: {
      label: 'What helps you most when emotionally overwhelmed?',
      type: 'radio',
      options: ['Breathing exercises to center', 'Gentle validation and processing', 'Mindful body awareness', 'Compassionate self-talk guidance']
    },
    primaryGoal: {
      label: 'What do you need most right now?',
      type: 'radio',
      options: ['Break emotional spiral', 'Process difficult feelings', 'Return to center', 'Feel less overwhelmed']
    },
    specificFocus: {
      label: 'Which feeling or event do you need to reset from?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  // Practitioner perspective questions
  practitionerTitle: 'Personalize Emotional Reset Session for Your Client',
  practitionerQuestions: {
    preferredStyle: {
      label: 'What helps your client most when emotionally overwhelmed?',
      type: 'radio',
      options: ['Breathing exercises to center', 'Gentle validation and processing', 'Mindful body awareness', 'Compassionate self-talk guidance']
    },
    primaryGoal: {
      label: 'What does your client need most right now?',
      type: 'radio',
      options: ['Break emotional spiral', 'Process difficult feelings', 'Return to center', 'Feel less overwhelmed']
    },
    specificFocus: {
      label: 'Which feeling or event does your client need to reset from?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerGroupTitle: 'Personalize Emotional Reset Session for Your Clients',
  practitionerGroupQuestions: {
    preferredStyle: {
      label: 'What helps your clients most when emotionally overwhelmed?',
      type: 'radio',
      options: ['Breathing exercises to center', 'Gentle validation and processing', 'Mindful body awareness', 'Compassionate self-talk guidance']
    },
    primaryGoal: {
      label: 'What do your clients need most right now?',
      type: 'radio',
      options: ['Break emotional spiral', 'Process difficult feelings', 'Return to center', 'Feel less overwhelmed']
    },
    specificFocus: {
      label: 'Which feeling or event do your clients need to reset from?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  groupTitle: 'Personalize Your Group Emotional Reset Session',
  groupQuestions: {
    groupEmotionalContext: {
      label: 'What type of group emotional support are you creating?',
      type: 'radio',
      options: ['Family processing difficult situation', 'Team dealing with workplace stress', 'Friends supporting each other', 'Support group session', 'Crisis response group', 'Therapy group activity']
    },
    sharedEmotionalState: {
      label: 'What emotional situation is your group facing together?',
      type: 'textarea',
      placeholder: 'Describe the shared experience, loss, stress, or emotional challenge...'
    },
    groupEmotionalNeeds: {
      label: 'What does your group need most right now?',
      type: 'radio',
      options: ['Collective grounding and centering', 'Space to process feelings together', 'Mutual support and validation', 'Guided emotional regulation for all']
    },
    emotionalIntensity: {
      label: 'What is the emotional intensity level of your group?',
      type: 'radio',
      options: ['High intensity - crisis or acute stress', 'Moderate intensity - ongoing difficulty', 'Mild intensity - general overwhelm', 'Mixed intensity levels within group']
    },
    supportStyle: {
      label: 'How does your group provide emotional support best?',
      type: 'radio',
      options: ['Shared silence and presence', 'Taking turns sharing feelings', 'Collective breathing and grounding', 'Guided group emotional processing']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  giftTitle: 'Personalize Emotional Reset for Your Loved One',
  giftQuestions: {
    // Using primaryGoal to match regular user questions - backend expects this field
    primaryGoal: {
      label: 'What emotion are they struggling with most?',
      type: 'radio',
      options: ['Anger or frustration', 'Sadness or grief', 'Anxiety or fear', 'Overwhelm or burnout', 'Confusion or uncertainty', 'Hurt or betrayal']
    },
    // Using specificFocus to match regular user questions - backend expects this field
    specificFocus: {
      label: 'What triggered these emotions?',
      type: 'textarea',
      placeholder: 'Optional - describe what happened or what they are going through...'
    },
    // Using preferredStyle to match regular user questions - backend expects this field
    preferredStyle: {
      label: 'What approach would help them most?',
      type: 'radio',
      options: ['Gentle validation and comfort', 'Grounding and centering techniques', 'Perspective and reframing', 'Release and letting go', 'Self-compassion focus']
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  }
};
